import styled from '@emotion/styled'
import { ApiDeposit, ApiLoan } from 'api/rtk-api'

import { MasterDetail, Section } from '../../../components/core-v2'
import { Errors } from '../../tradebuilder-v2/util'
import { EditCashInstrumentsActions } from '../state/edit-cash-instruments-slice'
import { CashInstrumentDetailsPanel } from './cash-inst-details-panel'
import { CashInstrumentsPanel } from './cash-inst-panel'

export type CashInstrumentsLayoutProps = {
  actions: EditCashInstrumentsActions
  availableCurrencies: string[]
  availableRefRates: string[]
  canProceed: boolean
  canUserSave: boolean
  errors: Errors
  instruments: (ApiDeposit | ApiLoan)[]
  isNew: boolean
  saveSuccess: boolean
  selectedInstrument?: ApiDeposit | ApiLoan
}

const StyledContentSection = styled.section`
  height: calc(100vh - 119px);
`

const CashInstrumentsLayout = ({
  actions,
  availableCurrencies,
  availableRefRates,
  canProceed,
  canUserSave,
  errors,
  instruments,
  isNew,
  saveSuccess,
  selectedInstrument
}: CashInstrumentsLayoutProps) => (
  <StyledContentSection>
    <MasterDetail
      detailChildren={
        <Section type="quaternary">
          <CashInstrumentDetailsPanel
            actions={actions}
            availableCurrencies={availableCurrencies}
            availableRefRates={availableRefRates}
            canProceed={canProceed && canUserSave}
            errors={errors}
            isNew={isNew}
            saveSuccess={saveSuccess}
            selectedInstrument={selectedInstrument}
          />
        </Section>
      }
      masterChildren={
        <Section type="primary">
          <CashInstrumentsPanel
            canUserSave={canUserSave}
            instruments={instruments as ApiDeposit[] | ApiLoan[]}
            selectedInstrument={selectedInstrument}
            onSearch={actions.search}
            onSelectInstrument={actions.setSelectedInstrument}
            onSelectNewInstrument={actions.setIsNew}
          />
        </Section>
      }
      width="normal"
    />
  </StyledContentSection>
)

export default CashInstrumentsLayout
